import { type BulkEmailUser } from "./types";

/**
 * Unique key for deduplication: email (primary) or id (fallback when email missing).
 * Handles bad upstream data where same person has different ids across room/event joins.
 */
const getDedupeKey = (user: BulkEmailUser): string => user.email || user.id;

/**
 * De-duplicates users by email, merging roles when the same person appears multiple times.
 * Falls back to id when email is missing. Handles bad upstream data (e.g. room/event
 * members returning the same person with different ids).
 */
export const deduplicateBulkEmailUsers = (users: BulkEmailUser[]): BulkEmailUser[] => {
  const seen = new Map<string, BulkEmailUser>();
  for (const user of users) {
    const key = getDedupeKey(user);
    const existing = seen.get(key);
    if (existing) {
      const mergedRoles = Array.from(new Set([...existing.roles, ...user.roles]));
      seen.set(key, { ...existing, roles: mergedRoles });
    } else {
      seen.set(key, user);
    }
  }
  return Array.from(seen.values());
};
